<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>施工管理</el-breadcrumb-item>
      <el-breadcrumb-item>结算订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="0" style="display: flex; flex-direction: column;justify-items: center; align-items: center;">
      <el-col :span="4">
        <!-- v-if="order_type === 0" -->
        <el-button type="primary" @click="get_jiesuan_add" v-if="false">结算订单</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="0" style="height: 10px;"></el-row>
    <el-row :gutter="0" class="el_row_two">{{ shangcheng_flag }}
      <orderList ref="orderListRef" :paizhao="paizhao" :caozuo_type="1" :query_flag="1" :add_flag="1" :order_type="order_type" :shangcheng_flag="0"   :key="datekey"  >
      </orderList>
      <el-dialog title="订单信息查看" :visible.sync="infoDialogVisible" width="90%">
        <kaidanFunc ref="kaidanFuncRef" :orderInfo="orderInfo" :diaoyongType="1" :key="datekey"> </kaidanFunc>
      </el-dialog>
      <el-dialog title="订单结算" :visible.sync="jiesuanDialogVisible" width="90%" >
        <jiesuanAdd ref="jiesuanAddFuncRef" :key="datekey" @jiesuan_addClose="jiesuan_addClose" > </jiesuanAdd>
      </el-dialog>

    </el-row>

    <!-- -->
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from './config/validator';
import orderList from './module/order_list.vue'
import jiesuanAdd from './module/jiesuan_add.vue'
export default {
  props: ['order_type', 'shangcheng_flag'], // order_type 0 未结算订单  1 已经结算订单
  components: {
    orderList: orderList,
    jiesuanAdd: jiesuanAdd
  },
  data() {
    return {
      order_type01: 0,
      orderInfo: {},
      datekey: Date.now(),
      paizhao: '',
      addDialogVisible: false,
      infoDialogVisible: false,
      jiesuanDialogVisible: false

    }
  },
  created() {
    console.log('shangcheng_flag', this.shangcheng_flag)
  },
  methods: {
    jiesuan_addClose() {
      this.jiesuanDialogVisible = false 
      this.getorderList();
    },
    async get_jiesuan_add() {
      this.jiesuanDialogVisible = true;
    },
    // orderOver(data) {
    //   // console.log(808)
    //   this.addDialogVisible = false
    //   this.getorderList();
    // },
    addDoalogClosed() {
      this.$refs.kaidanAddRef.input_init();
    },
    getorderList() {
      this.$refs.orderListRef.getorderList_flush()
    }
  }
}

</script>
<style lang="less" scoped></style>
